import { getOktaTokensFromLocalStorage } from "../utils/token.utils";
import { mapSSO } from "./mapAuthProvider";
import { oktaAuth } from "./oktaAuthProvider";
/**
 * @remarks
 *
 * AccessToken should always be used for Authentication purposes in APIs.
 *
 * @see {@link https://auth0.com/blog/id-token-access-token-what-is-the-difference/} accessToken vs idToken
 */
export const buildAuthorizationHeader = async () => {
    const mapToken = await buildMapHeader();
    const oktaTokens = getOktaTokensFromLocalStorage();
    if (oktaTokens?.accessToken && typeof oktaTokens?.accessToken === "string") {
        if (mapToken) {
            // Okta + MAP tokens both exist - return Okta token as is
            return `Bearer ${oktaTokens.accessToken}`;
        }
        // Only Okta tokens exist - renew them if needed
        const renewedAccessTokenString = await verifyAndRefreshOktaAccessToken();
        return `Bearer ${renewedAccessTokenString}`;
    }
    // Either only MAP tokens exist or no tokens exist
    return `Bearer ${mapToken}`;
};
export const buildMapHeader = async () => {
    return await verifyAndRefreshMapAccessToken();
};
export const verifyAndRefreshMapAccessToken = async () => {
    try {
        const accessToken = mapSSO.tokenManager.accessToken;
        if (accessToken && !mapSSO.tokenManager.hasExpired(accessToken)) {
            return accessToken.token;
        }
        const renewedTokens = await mapSSO.tokenManager.renew();
        return renewedTokens?.accessToken?.token || "";
    }
    catch (error) {
        return "";
    }
};
const isAccessToken = (token) => {
    return token !== undefined && "accessToken" in token;
};
export const verifyAndRefreshOktaAccessToken = async () => {
    try {
        const tokenName = "accessToken";
        const accessToken = await oktaAuth.tokenManager.get(tokenName);
        if (isAccessToken(accessToken) && !oktaAuth.tokenManager.hasExpired(accessToken)) {
            return accessToken.accessToken;
        }
        const renewedToken = await oktaAuth.tokenManager.renew(tokenName);
        return renewedToken?.accessToken ?? "";
    }
    catch (error) {
        return "";
    }
};
//# sourceMappingURL=authHeaders.js.map